import React, { useEffect } from "react";
import { navigate, A } from "hookrouter";

import styles from "./Story.module.css";
import { BsBookHalf } from "react-icons/bs";
import { FaEdit, FaHeart, FaPlus } from "react-icons/fa";
import cogoToast from "cogo-toast";
import AuthContext from "../../../contexts/AuthContext";

const Header = ({ firstChapter, novel }) => {
  const story = novel;
  const { user } = React.useContext(AuthContext);
  const { token } = React.useContext(AuthContext);
  const [newLib, setNewLib] = React.useState("");
  const [inReadingList, setInReadingList] = React.useState(false);
  const [userLibraries, setUserLibraries] = React.useState([]);
  const [listOpen, setListOpen] = React.useState(false);
  const [votes, setVotes] = React.useState(0);
  const [voteDisabled, setVoteDisabled] = React.useState(false);
  const bookByUser =
    novel.postedBy && novel.postedBy.author
      ? novel.postedBy.author._id
        ? novel.postedBy.author._id === user._id
        : novel.postedBy.author === user._id
      : false;

  const handleListOpen = (e) => {
    console.log();
    if (e.target.tagName !== "INPUT") {
      setListOpen(!listOpen);
    }
  };

  useEffect(() => {
    setVotes(novel.totalLikes);
  }, [novel]);

  const getLibraryList = async () => {
    const rawResponse = await fetch("https://api.yazbie.com/api/libraries", {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: token,
      },
    });
    try {
      let content = await rawResponse.clone().json();

      setUserLibraries(
        content.libraries.map((library) => ({
          ...library,
          already:
            library.Stories.filter((s) => s._id === story._id).length > 0,
        }))
      );

      if (content && content.success) {
        return content;
      } else if (content && !content.success) {
        cogoToast.error(content.message);
      }
    } catch (err) {
      console.log(err);
      // console.log(await rawResponse.clone().text());
      cogoToast.error(await rawResponse.clone().text());
      return false;
    }
  };

  const createList = (storyId, libName) => {
    (async () => {
      const rawResponse = await fetch(
        "https://api.yazbie.com/api/libraries/create",
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: token,
          },
          body: JSON.stringify({ libName: libName, Stories: [storyId] }),
        }
      );
      try {
        let content = await rawResponse.clone().json();
        console.log(content);
        if (content && content.success) {
          cogoToast.success(content.message);
          checkReadingList();
        } else if (content && !content.success) {
          cogoToast.error(content.message);
        }
      } catch (err) {
        console.log(err);
        // console.log(await rawResponse.clone().text());
        cogoToast.error(await rawResponse.clone().text());
      }
    })();
  };

  const voteForNovel = () => {
    setVoteDisabled(true);
    (async () => {
      const rawResponse = await fetch(
        `https://api.yazbie.com/api/stories/postVote/${story._id}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );
      try {
        let content = await rawResponse.clone().json();
        console.log(content);
        if (content && content.success) {
          cogoToast.success(content.message);
          setVotes(votes + 1);
          checkReadingList();
        } else if (content && !content.success) {
          cogoToast.error(content.message);
        }
      } catch (err) {
        console.log(err);
        // console.log(await rawResponse.clone().text());
        cogoToast.error(await rawResponse.clone().text());
      }
    })();
  };

  const updateList = (libId, libName, stories) => {
    (async () => {
      const rawResponse = await fetch(
        `https://api.yazbie.com/api/libraries/update/${libId}`,
        {
          method: "PUT",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: token,
          },
          body: JSON.stringify({ libName: libName, Stories: stories }),
        }
      );
      try {
        let content = await rawResponse.clone().json();
        console.log(content);
        if (content && content.success) {
          cogoToast.success(content.message);
          checkReadingList();
        } else if (content && !content.success) {
          cogoToast.error(content.message);
        }
      } catch (err) {
        console.log(err);
        // console.log(await rawResponse.clone().text());
        cogoToast.error(await rawResponse.clone().text());
      }
    })();
  };

  const checkReadingList = async () => {
    const libraries = await getLibraryList();
    let readingList = null;
    const userLibrariesTemp = libraries.libraries
      .filter((library) => library.libName !== "My Reading List")
      .map((library) => {
        library.value = library.libName;
        library.label = library.libName;
        return library;
      });
    setUserLibraries(userLibrariesTemp);
    libraries.libraries.forEach((library) => {
      if (library.libName === "My Reading List") {
        readingList = library;
      }
    });
    if (readingList) {
      let existingStories = [];
      readingList.Stories.forEach((story) => {
        existingStories = [...existingStories, story._id];
      });
      if (existingStories.includes(story._id)) {
        setInReadingList(true);
      } else {
        setInReadingList(false);
      }
    }
  };

  const handleLibraryDropdownChange = (newValue) => {
    // add story to current list
    let existingStories = [story._id];
    if (newValue?.Stories) {
      newValue.Stories.forEach((story) => {
        existingStories = [...existingStories, story._id];
      });
      updateList(newValue._id, newValue.value, existingStories);
    } else if (newValue) {
      console.log(story._id);
      createList(story._id, newValue);
    }
  };

  useEffect(() => {
    getLibraryList();
    // checkReadingList();
  }, []);

  return (
    <div
      className={styles.header}
      style={{
        backgroundImage: `url(${story.coverImage}), url(${story.coverImageBackup})`,
      }}
    >
      <div className={styles.overlay} />
      <div className={styles.content}>
        <div className={styles.title}>{story.title}</div>
        <div className={styles.desc}>
          {story.tags &&
            story.tags.map((tag, index) => (
              <A href={`/browse/${tag}/tag`} key={index}>
                <div className={styles.tag}>{tag}</div>
              </A>
            ))}
        </div>

        <A href={`/user/${story.postedBy?.author}`} className={styles.author}>
          <img
            className={styles.image}
            src="https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fcdn.iconscout.com%2Ficon%2Ffree%2Fpng-256%2Favatar-380-456332.png&f=1&nofb=1"
            alt=""
          />
          {story.postedBy
            ? story.postedBy.name || story.postedBy.author.name
            : ""}
        </A>
        <div></div>

        <div className={styles.buttons}>
          <button
            className={styles.read}
            onClick={() =>
              navigate(`/episode/${story._id}/${firstChapter._id}`)
            }
          >
            <BsBookHalf /> Read Now
          </button>

          {bookByUser ? (
            <React.Fragment>
              <button
                className={styles.read + " " + styles.outline}
                onClick={() => navigate(`/episode/new/${story._id}`)}
              >
                <FaEdit /> Write
              </button>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <button
                className={
                  styles.read +
                  " " +
                  styles.outline +
                  " " +
                  styles.small +
                  " " +
                  styles.heart
                }
                onClick={voteForNovel}
                disabled={voteDisabled}
              >
                <FaHeart />
              </button>
              <button
                className={
                  styles.read + " " + styles.outline + " " + styles.small
                }
                onClick={handleListOpen}
              >
                <FaPlus />
                {listOpen && (
                  <div className={styles.libList}>
                    <div>Add to List</div>
                    {userLibraries.map((lib, index) => (
                      <div
                        className={styles.libListItem}
                        name={lib._id}
                        key={index}
                        onClick={() => handleLibraryDropdownChange(lib)}
                      >
                        {lib.libName}
                      </div>
                    ))}
                    {/* <div className={styles.libListItem} data-lib={{}}>
                      My library
                    </div>
                    <div className={styles.libListItem} data-lib={{}}>
                      Foof oof
                    </div> */}
                    <div>
                      <input
                        type="text"
                        placeholder={"Add New List"}
                        value={newLib}
                        onChange={(e) => setNewLib(e.target.value)}
                      />
                      <button
                        onClick={() => handleLibraryDropdownChange(newLib)}
                      >
                        <FaPlus />
                      </button>
                    </div>
                  </div>
                )}
              </button>
            </React.Fragment>
          )}
        </div>
      </div>

      <div className={styles.photo}>
        <img
          src={story.coverImage || story.coverImageBackup}
          onError={(e) =>
            story.coverImageBackup !== e.target.src
              ? (e.target.src = story.coverImageBackup)
              : ""
          }
          alt="Cover"
        />
        <div className={styles.mobileTitle}>{story.title}</div>
        <div className={styles.stats}>
          <div className={styles.stat}>
            <div className={styles.statData}>{story.totalReadNo}</div>{" "}
            <div>Reads</div>
          </div>
          <div className={styles.stat}>
            <div className={styles.statData}>{votes}</div>{" "}
            <div>Votes</div>
          </div>
          <div className={styles.stat}>
            <div className={styles.statData}>{story.episodes}</div>{" "}
            <div>Episodes</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
